import {
    bexHttpClient
} from 'shared/api/clients';

/**
 * Service class for performing template operations.
 */

class TableTemplateService {
    async saveSchemaTemplate(oragID, appID, template) {
        // #414 — routed through platform-server (session + org-ownership auth),
        // which forwards to FEO over the X-FEO-Service-Key channel. The browser
        // no longer calls FEO directly. /api → /cm ingress rewrite maps this to
        // the server route /cm/feo/template/:org/:app.
        const response = await bexHttpClient.post(`/feo/template/${oragID}/${appID}`, template);
        return response;
    }
}

const tableTemplateService = new TableTemplateService();
export { tableTemplateService };